module.exports = __webpack_public_path__ + "static/Relevant-Bold-31546a5e567db3bed036a1df5670eb62.woff";